import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import * as orderDetailActions from 'app/core/store/order-detail/order-detail.actions';
import { OrderDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { AbstractCalendarFlorderTooltipContainer } from 'app/modules/calendar/common/calendar-tooltip/abstract-calendar-florder-tooltip.container';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-calendar-order-tooltip',
  templateUrl: './calendar-order-tooltip.container.html',
  styleUrls: ['../../common/calendar-tooltip/calendar-florder-tooltip.container.scss'],
})
export class CalendarOrderTooltipContainer extends AbstractCalendarFlorderTooltipContainer {
  orderDetail: OrderDetail;
  private loadedEtmOrderNrForTooltip: string;
  private loadedSalesOrderNrForTooltip: string;
  private customerIds: string[] = [];

  protected getFlorderFromStore() {
    this.store
      .pipe(
        takeWhile(() => !this.destroyed),
        map(state => state.editOrderDetail.orderDetail),
        distinctUntilChanged()
      )
      .subscribe(orderDetail => {
        this.orderDetail = orderDetail;
        this.loadedEtmOrderNrForTooltip = (orderDetail && orderDetail.etmOrderNumber) || null;
        this.loadedSalesOrderNrForTooltip = (orderDetail && orderDetail.salesOrderNumber) || null;
        this.cd.markForCheck();
      });
    this.store
      .pipe(
        takeWhile(() => !this.destroyed),
        map(state => {
          return {
            isSuperUser: state.session.userContext.isSuperUser,
            allowedCustomers: state.session.customerPermissions.data.calenderLegend,
          };
        }),
        distinctUntilChanged()
      )
      .subscribe(({ allowedCustomers, isSuperUser }) => {
        this.customerIds = isSuperUser ? allowedCustomers.map(c => c.id) : [];
        this.cd.markForCheck();
      });
  }

  protected loadFlorder() {
    const salesOrderNumber = this.florderInfo.salesOrderNumbers && this.florderInfo.salesOrderNumbers[0];
    if (this.loadedEtmOrderNrForTooltip !== this.florderInfo.etmOrderNumber) {
      this.loadedEtmOrderNrForTooltip = this.florderInfo.etmOrderNumber;
      this.store.dispatch(
        new orderDetailActions.OrderDetailOpenAction({
          etmOrderNumber: this.florderInfo.etmOrderNumber,
          salesOrderNumber,
          customerIds: this.customerIds,
        })
      );
    }
  }
}
